import React from 'react';
import { useTenantContext } from '../components/App/AppTenant';
import MainLayout, { useMainLayoutContext } from '../components/MainLayout';
import EqxButton from '../shared/components/EqxButton/EqxButton';
import EqxCard from '../shared/components/EqxCard/EqxCard';
import EqxError from '../shared/components/EqxError';

// Main content component extracted from PageLMS
const LMSContent: React.FC = () => {
    const tenant = useTenantContext();
    const mainContext = useMainLayoutContext()

    const handleOpenLMS = () => {
        if (tenant.lmsRootURL) {
            window.open(tenant.lmsRootURL, '_blank');
        }
    };

    // Check allowed - moved after all hooks to follow Rules of Hooks
    if (!tenant.isLMSEnabled) {
        return <EqxError error="LMS is not enabled for this business" />;
    }
    if (!mainContext.permissions?.canAccessLMS) {
        return <EqxError error="Your user does not have permission to access the Learning Management System. Please contact the support team." />;
    }

    return (
        <EqxCard isSection={true}>
            <div className="text-center">
                <h3 className="mb-4">
                    <i className="fas fa-graduation-cap me-2"></i>
                    Learning Management System
                </h3>
                <p className="text-muted mb-4">
                    Access your training courses and learning materials through our Learning Management System.
                </p>
                <EqxButton
                    text="Open LMS"
                    icon="fas fa-external-link-alt"
                    variant="primary"
                    size="lg"
                    onClick={handleOpenLMS}
                    className="px-5 py-3"
                    showText={true}
                    fullWidth={true}
                />
            </div>
        </EqxCard>
    );
};

const PageLMS: React.FC = () => {
    return (
        <MainLayout pageTitle="Learning Management System">
            <LMSContent />
        </MainLayout>
    );
};

export { PageLMS as default };

